<!-- "components tags" are not recognised by the Browser, so it sets the default display value = 'inline' for the host element -->
<!-- in order to solve height issues, we set the component's main div display: block -->
<!-- see: https://nitayneeman.com/posts/solving-a-styling-issue-for-rendered-components-in-angular/ -->

<div class="container-fluid" style="display: block;">
  <!-- Entete de la custom grid Titre et Infos Filtres-->
  <div *ngIf="loadGrid && (GridXml?.titre || GridXml?.rowFilter?._strTextSql)" class="row no-gutters">
    <div class="col-3 q-grey">
      <h5 *ngIf="loadGrid && GridXml?.titre" class="text-center pt-2 mb-0  font-weight-bold ">{{GridXml.titre}}</h5>
      <h6 *ngIf="loadGrid && GridXml?.titre" class="text-center" style="font-size: 13px;">Edition du {{dateToday | date:'dd-MM-yyyy'}}</h6>
      <h6 *ngIf="loadGrid && GridXml?.titre" class="text-center" style="font-size: 8px;">({{customgridname}})</h6>
    </div>
    <div class="col-9 q-light-grey">
      <div *ngIf="loadGrid && GridXml?.rowFilter?._strTextSql" class="m-2" style="font-size: 12px; height: 72px; overflow-y:scroll;" [innerHTML]="GridXml.rowFilter._strTextSql"></div>
    </div>
  </div>

  <!-- Bouton export csv excel custom -->
  <div class="row no-gutters">
    <div class="d-flex align-items-center col-12" [ngStyle]="{'min-height': (showConfigButtons || showExportButtons || (activebutton && activebutton.length > 0)) ? '36px' : '0' }"   >

      <button *ngIf="gridHasRow && (showConfigButtons || showExportButtons)" type="button" class="btn csvBtn" title="Agrandir - Rétrécir les colonnes" (click)="onBtSizeColumn()">
        <i [ngClass]="[autoSizeColumns ? 'fa fa-compress' : 'fa fa-expand']"></i>
      </button>


      <button *ngIf="gridHasRow && showExportButtons" type="button" class="btn csvBtn" title="CSV" (click)="onBtExport()">
        <i class="fas fa-file-csv" title="download csv"></i>
      </button>
      <button *ngIf="gridHasRow && showExportButtons" type="button" class="btn csvBtn" title="Excel" (click)="onBtExportExcel()">
        <i class="fas fa-file-excel" title="download Excel"></i>
      </button>

      <ng-container *ngFor="let btn of activebutton">
        <button type="button" *ngIf="gridHasRow || btn.ID.toUpperCase() === 'btnModeCreer'.toUpperCase() || btn.ID.toUpperCase() === 'btnImporter'.toUpperCase()" [ngClass]="setClassBtn(btn)" (click)="action(btn)" title="{{setBtnTip(btn)}}">
          <i [class]="setClassBtnImg(btn)"></i>
        </button>
      </ng-container>

      <div class="config-buttons-container" *ngIf="showConfigButtons && columnConfigKey && gridApi">
        <i class="fas fa-wrench px-2"></i>
        <q-customgrid-button class="csvBtn" [customgridName]="columnConfigKey" [grid]="gridApi"></q-customgrid-button>
        <q-customgrid-button class="csvBtn" [customgridName]="columnConfigKey" [grid]="gridApi" delete></q-customgrid-button>
      </div>
    </div>
  </div>

  <!-- AG-GRID -->
  <div class="row no-gutters" [ngClass]="showConfigButtons || showExportButtons?'mt-2':'mt-0'" *ngIf="gridHasRow">
    <div class="col-12">
      <div [ngStyle]="customgridStyle">
        <ag-grid-angular *ngIf="loadGrid" class='ag-theme-balham h-100 w-100'                        
                         [gridOptions]="gridOptions"
                         (filterChanged)="OnFilterChanged($event)"
                         (sortChanged)="OnSortChanged($event)"
                         (gridReady)="onGridReady($event)"
                         (selectionChanged)="OnSelectionChanged($event)"
                         (rowClicked)="OnRowClicked($event)"
                         (rowDoubleClicked)="OnRowDoubleClicked($event)"
                         (cellClicked)="onCellClicked($event)"
                         (cellValueChanged)="OnCellValueChanged($event)"
                         (rowDataUpdated)="OnRowDataUpdated($event)"
                         #agGrid>
        </ag-grid-angular>
      </div>
    </div>
  </div>


  <div class="mt-3" *ngIf="!gridHasRow">
    <div class="q-nodata q-c-light-main text-center">
      <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
      Aucune donnée
    </div>

    <!--<div class="col-12">
      <h5 class="text-center" *ngIf="!gridHasRow" style="font-weight:bold; font-size: 1rem;">Aucunes données à afficher</h5>
    </div>-->
  </div>

  <div *ngIf="isLoading" class="ag-custom-loading-cell" style="padding-left: 10px; line-height: 25px;">
    <i class="fas fa-spinner fa-pulse"> </i>
    <span>Chargement des données en cours, merci de patienter.</span>
  </div>
</div>

